export default "__VITE_ASSET__e25eaa26__"